const XAI_USD_TICKS_PER_DOLLAR = 10_000_000_000

export function xaiCostUsdFromTicks(ticks: number | undefined): number {
    return ticks !== undefined && Number.isFinite(ticks) ? ticks / XAI_USD_TICKS_PER_DOLLAR : 0
}
